module.exports = __webpack_public_path__ + "static/media/mobile.23458109.jpeg";